import { useStyles, useSettings } from '@wix/tpa-settings/react';
import settingsParams from '../../settingsParams';
import stylesParams from '../../stylesParams';
import { getIdsFromFonts, getIdsFromSettings } from './ids';
import { useSelector } from 'react-redux';
import { getSiteOwnerId } from '../redux/hydrated-data/hydrated-data';

export function useIds() {
  const settings = useSettings();
  const styles = useStyles();
  const siteOwnerId = useSelector(getSiteOwnerId);
  const useIdsFromSettings = settings.get(settingsParams.useIdsFromSettings);
  const idsFromFonts = getIdsFromFonts(
    styles.get(stylesParams.channelId),
    styles.get(stylesParams.videoId),
    siteOwnerId,
  );
  const idsFromSettings = getIdsFromSettings(
    settings.get(settingsParams.channelId),
    settings.get(settingsParams.videoId),
    siteOwnerId,
  );

  if (useIdsFromSettings) {
    return idsFromSettings;
  }

  return idsFromFonts;
}
